import { render, staticRenderFns } from "./SelectImagesDialog.vue?vue&type=template&id=2c724032&"
import script from "./SelectImagesDialog.vue?vue&type=script&lang=js&"
export * from "./SelectImagesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports